import { useEffect, useLayoutEffect, useState } from "react";
export const useScrollYCoord = () => {
    const [scrollDirection, setScrollDirection] = useState(0);
    const toggleScrollDirection = () => {
        const { scrollY } = window;
        if (scrollY === 0) {
            setScrollDirection(0);
        }
        else {
            setScrollDirection(scrollY);
        }
    };
    useEffect(() => {
        window.addEventListener("scroll", toggleScrollDirection);
        return () => {
            window.removeEventListener("scroll", toggleScrollDirection);
        };
    });
    return scrollDirection;
};
export const useScreenWidth = () => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    useLayoutEffect(() => {
        const handleResize = () => {
            const { innerWidth } = window;
            setScreenWidth(innerWidth);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return screenWidth;
};
